export function toPagePattern(routeId: string): string {
  const stripped = routeId.replace(/^\/_app(?=\/|$)/, '').replace(/\/+$/, '');
  return (stripped || '/')
    .replace(/\{-\$([^/{}]+)\}/g, ':$1?')
    .replace(/\{\$([^/{}]+)\}/g, ':$1')
    .replace(/\$([^/{}]+)/g, ':$1')
    .replace(/\/\$$/, '/*');
}

type MatchLike = {
  routeId: string;
  fullPath?: string;
  status?: string;
  globalNotFound?: boolean;
  staticData?: unknown;
};

export function resolveViewedPage(matches: MatchLike[]): { pattern: string; title: unknown } | null {
  const match = matches[matches.length - 1];
  if (!match || match.routeId === '__root__') return null;
  if (matches.some((m) => m.globalNotFound === true || m.status === 'notFound')) return null;
  return { pattern: toPagePattern(match.fullPath ?? match.routeId), title: (match.staticData as { title?: unknown } | undefined)?.title };
}
